module.exports = __webpack_public_path__ + "img/nutrition-less-alcohol.ae87fa9.svg";